export enum Countries {
  POLAND = 'PL',
  LITHUANIA = 'LT',
  LATVIA = 'LV',
  ESTONIA = 'EE',
}
